import { colors } from '@frontend/constants';
import { useMemo, type ReactNode } from '@frontend/react';
import { usePaywallContext } from '@frontend/react-domain';
import { FocusTrap, Modal, useIsOnMobile } from '@frontend/web-react';
import { PaywallHeader } from '../PaywallHeader';

export const PaywallModalView = ({
  children,
  Footer,
  isOpen,
  onClose,
}: {
  Footer?: ReactNode;
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const {
    paywallState: {
      navigation: { shouldCompleteOnboardingOnClose },
    },
  } = usePaywallContext();
  const isMobile = useIsOnMobile();

  const overlayProps = useMemo(
    () =>
      shouldCompleteOnboardingOnClose
        ? {
            backgroundOpacity: 0,
            style: { backgroundColor: colors.cream[50] },
          }
        : {},
    [shouldCompleteOnboardingOnClose],
  );

  return (
    <Modal
      Footer={Footer}
      Header={<PaywallHeader />}
      closeOnClickOutside={false}
      closeOnEscape={false}
      fullScreen={isMobile}
      isOpen={isOpen}
      onClose={onClose}
      overlayProps={overlayProps}
      padding="md"
      size={isMobile ? '100%' : '700px'}
      stickyFooter
      stickyHeader
      trapFocus
      withCloseButton={false}
      withOverlay
    >
      <FocusTrap.InitialFocus />
      {isOpen ? children : null}
    </Modal>
  );
};
